/**
 * Password configuration constants
 * Shared between client and server - no environment dependencies
 *
 * QC password rules: either 10+ chars (any), or 7+ chars with at least 2 of
 * (uppercase, number, special character).
 */

export const QC_PASSWORD_CONFIG = {
  longMinLength: 10,
  shortMinLength: 7,
  shortRequiredCategories: 2,
} as const;

/** Absolute minimum length across all rules for the current tenant. */
export const getMinPasswordLength = () => QC_PASSWORD_CONFIG.shortMinLength;

// Export type for use in other modules
